import { Content } from "@r8er/components/marketing/content";
import { Layout } from "@r8er/components/marketing/layout";
import Head from "next/head";
import type { PropsWithChildren } from "react";

export default function ErrorLayout({
  children,
  className,
  title = "An error occured",
  isApp,
  showRedirect = true,
}: PropsWithChildren<{
  title?: string;
  className?: string;
  isApp?: boolean;
  showRedirect?: boolean;
}>) {
  return (
    <Layout>
      <Head>
        <title>{`${title} - R8ER`}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>
      <Content isFullWidth isCentered isLightGrey>
        {isApp && children ? (
          children
        ) : (
          <>
            <h1
              style={{
                color: "var(--brand-secondary)",
              }}
            >
              404 - Page Not Found
            </h1>
            <p>The page you requested has been moved or never existed.</p>
          </>
        )}
      </Content>
    </Layout>
  );
}
